import { gql } from 'apollo-boost';

export const CREATE_BUSINESS_GROUP_GQL = gql`
  mutation BusinessGroupCreate($name: String!) {
    business_group_create(input: { name: $name }) {
      business_group {
        id
        name
        created_at
        updated_at
        businesses {
          id
          name
        }
      }
    }
  }
`;
